import { PostTravelersStandByTravelersResponse } from 'src/sdk_checkin';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from 'src/lib';
import { GetStandbyTravelersResultModel } from './get-standby-travelers-result.state';

/** StateDetailsActions */
const ACTION_SET = '[GetStandbyTravelersResult] set';
const ACTION_UPDATE = '[GetStandbyTravelersResult] update';
const ACTION_RESET = '[GetStandbyTravelersResult] reset';
const ACTION_FAIL = '[GetStandbyTravelersResult] fail';
const ACTION_CANCEL_REQUEST = '[GetStandbyTravelersResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetStandbyTravelersResult] set from api';
const ACTION_UPDATE_FROM_API = '[GetStandbyTravelersResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetStandbyTravelersResult = createAction(
  ACTION_SET,
  props<WithRequestId<GetStandbyTravelersResultModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetStandbyTravelersResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<GetStandbyTravelersResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetStandbyTravelersResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetStandbyTravelersResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetStandbyTravelersResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetStandbyTravelersResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<PostTravelersStandByTravelersResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetStandbyTravelersResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<PostTravelersStandByTravelersResponse>>()
);
